export class variaveisCabecalho {
    public titulo: string;
    public textoCampo: string;
    public ordem: number = 0;
    public tipoResultadoCampo: number | undefined = undefined;
    public tipoResultado: number | undefined = undefined; //só ser o tipoResultadoCampo for 2 ou  3
    public consulta: string;
    public ehConsultaDerivada: boolean;
    public indice: string;
    constructor(
        titulo: string = "",
        textoCampo: string = "",
        ordem: number = 0,
        tipoResultadoCampo: number | undefined = undefined,
        tipoResultado: number | undefined = undefined, 
        consulta: string = "", ehConsultaDerivada: boolean = false,
        indice: string = "") {
      this.titulo = titulo;
      this.textoCampo = textoCampo;
      this.ordem = ordem;
      this.tipoResultadoCampo = tipoResultadoCampo;
      this.tipoResultado = tipoResultado;
      this.consulta = consulta;
      this.ehConsultaDerivada = ehConsultaDerivada;
      this.indice = indice;
    }
}